module.exports = __webpack_public_path__ + "static/media/ICONS_ALMACENES.c4fc3511.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ICONS/ICONS_ALMACENES.svg
// module id = 479
// module chunks = 0